module.exports = __webpack_public_path__ + "img/illustrator-cc.93ceeb6a.svg";